import { Track } from './Track';
/**
 * Feeds one source track of unencoded audio to several consumers, each on
 * its own Track: a Track has exactly one listener, so two encoders started
 * on the same track would steal each other's frames (the viewer, RTMP and
 * low-quality composite encoders all read the mixed capture). Every
 * consumer but the last gets a copy of the samples; the last one gets the
 * original buffer.
 */
export class AudioTrackFanout {
    source;
    trackId;
    outputs = new Map();
    attached = false;
    constructor(source, trackId) {
        this.source = source;
        this.trackId = trackId;
    }
    add(key) {
        const existing = this.outputs.get(key);
        if (existing)
            return existing;
        const track = new Track(this.trackId, true);
        this.outputs.set(key, track);
        if (!this.attached) {
            this.attached = true;
            this.source.setListener(this.onFrame);
        }
        return track;
    }
    remove(key) {
        const track = this.outputs.get(key);
        if (!track)
            return;
        this.outputs.delete(key);
        track.emit(undefined, true);
        if (this.outputs.size === 0 && this.attached) {
            this.attached = false;
            this.source.unsetListener();
        }
    }
    size() {
        return this.outputs.size;
    }
    destroy() {
        for (const key of [...this.outputs.keys()])
            this.remove(key);
    }
    onFrame = async (frame, done) => {
        const targets = [...this.outputs.values()];
        if (done) {
            for (const target of targets)
                target.emit(undefined, true);
            return;
        }
        if (!frame)
            return;
        targets.forEach((target, i) => {
            const last = i === targets.length - 1;
            const copy = last ? frame : { ...frame, data: frame.data.slice() };
            target.emit(copy, false, [copy.data.buffer]);
        });
    };
}
